export const basePath = process.env.REACT_APP_API_URL;
export const uploadPath = process.env.REACT_APP_UPLOAD_PATH;
const generateFormData = (json) => {
  console.log("json: ", json);
  const formData = new FormData();
  for (const key in json) {
    if (json.hasOwnProperty(key)) {
      const value = json[key];
      if (Array.isArray(value)) {
        value.forEach((item) => formData.append(key, item));
      } else {
        formData.append(key, value);
      }
    }
  }
  return formData;
};

const fetchDataWithToken = async (url, options = {}) => {
  try {
    const response = await fetch(basePath + url, {
      ...options,
      headers: {
        ...options.headers,
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    });
    return await response.json();
  } catch (error) {
    console.error("Error fetching data with token:", error);
    return null;
  }
};

const fetchDataWithoutToken = async (url, options = {}) => {
  try {
    const response = await fetch(basePath + url, {
      ...options,
      headers: {
        ...options.headers,
        "Content-Type": "application/json",
      },
    });
    return await response.json();
  } catch (error) {
    console.error("Error fetching data without token:", error);
    return null;
  }
};


export const getPositions = async () => {
  const res = await api.get("/getPositions");
  return res.data;
};
export const fetchData = {
  // GET request with token (for protected endpoints)
  get: async (url) => {
    try {
      return await fetchDataWithToken(url);
    } catch (error) {
      console.error(`Error fetching data for ${url}:`, error);
      return null;
    }
  },

  // GET request without token (for public endpoints)
  getWithoutToken: async (url) => {
    try {
      return await fetchDataWithoutToken(url);
    } catch (error) {
      console.error(`Error fetching data for ${url}:`, error);
      return null;
    }
  },

  // POST request with token (for protected endpoints)
  post: async (url, data) => {
    try {
      const response = await fetch(basePath + url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (error) {
      console.error("Error with POST request:", error);
      return null;
    }
  },

  // POST request with token (for protected endpoints)
  postWithoutToken: async (url, data) => {
    try {
      const response = await fetch(basePath + url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (error) {
      console.error("Error with POST request:", error);
      return null;
    }
  },

  postFormData: async (url, formData) => {
    try {
      const response = await fetch(basePath + url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        body: formData,
      });

      return await response.json();
    } catch (error) {
      console.error("Error with POST FormData request:", error);
      return null;
    }
  },

  put: async (url, data) => {
    try {
      const response = await fetch(basePath + url, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (error) {
      console.error("Error with PUT request:", error);
      return null;
    }
  },

  putWithFormData: async (url, data) => {
    try {
      const response = await fetch(basePath + url, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        body: generateFormData(data),
      });

      return await response.json();
    } catch (error) {
      console.error("Error with PUT request:", error);
      return null;
    }
  },

  // PUT request without token (for public endpoints)
  putWithoutToken: async (url, data) => {
    try {
      const response = await fetch(basePath + url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (error) {
      console.error("Error with PUT request:", error);
      return null;
    }
  },

  // DELETE request with token (for protected endpoints)
  delete: async (url) => {
    try {
      const response = await fetch(basePath + url, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });
      return await response.json();
    } catch (error) {
      console.error("Error with DELETE request:", error);
      return null;
    }
  },

  // DELETE request without token (for public endpoints)
  deleteWithoutToken: async (url) => {
    try {
      const response = await fetch(basePath + url, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      });
      return await response.json();
    } catch (error) {
      console.error("Error with DELETE request:", error);
      return null;
    }
  },

  // POST request with FormData (used for uploading files)
  postWithFormData: async (url, formData) => {
    try {
      const response = await fetch(basePath + url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Add token if available
        },
        body: generateFormData(formData),
      });

      return await response.json(); // Assuming the server responds with JSON
    } catch (error) {
      console.error("Error with FormData POST:", error);
      return null;
    }
  },

  putWithFormData: async (url, formData) => {
    try {
      const response = await fetch(basePath + url, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        body: generateFormData(formData),
      });
      return await response.json();
    } catch (error) {
      console.error("Error with FormData POST:", error);
      return null;
    }
  },

  // POST request without FormData (public)
  postWithoutFormData: async (url, data) => {
    try {
      const response = await fetch(basePath + url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      return await response.json();
    } catch (error) {
      console.error("Error with POST request:", error);
      return null;
    }
  },
  deleteOpening: async (url, body) => {
    try {
      const response = await fetch(basePath + url, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    } catch (error) {
      console.error("Error with DELETE Opening request:", error);
      return null;
    }
  },
};

export const api = {



  fetchJobPositions: async () => {
  const data = await fetchData.get("api/getPositions");

  if (data?.message === "Invalid or expired token.") {
    window.location.href = "/sign-in";
  }

  return data;
},
  // signIn: async ({ email, password }) => {
  //   try {
  //     const data = await fetchData.post("/api/login", {
  //       email,
  //       password,
  //     });

  //     return data;
  //   } catch (error) {
  //     console.error("Login error:", error);
  //     return { success: false, error: error.message };
  //   }
  // },

  signIn: async (body = {}) => {
    const data = await fetchData.post(`api/login`, body);
    if (data && typeof data === "object" && "token" in data) {
      sessionStorage.setItem("token", data.token);
      sessionStorage.setItem("user", JSON.stringify(data.user));
    }
    return data ? data : {};
  },

  signOut: async () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");
    window.location.href = "/sign-in";
  },

  fetchInquiries: async (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    const url = `api/getInquiries${queryString ? `?${queryString}` : ""}`;

    const data = await fetchData.get(url);
    if (data.message === "Invalid or expired token.") {
      window.location.href = "/sign-in";
    }
    return data;
  },

  deleteQueryies: async (queryId = "") => {
    const url = `api/inquiry?id=${queryId}`;
    const data = await fetchData.delete(url);
    if (data?.message && data?.message === "Invalid or expired token.") {
      window.location.href = "/sign-in";
    }
    return data;
  },

  updateQueryies: async (queryId = "", queryObject = {}) => {
    const url = `api/inquiry/${queryId}/status`;
    if (typeof queryObject === "object" && Object.keys(queryObject).length) {
      const data = await fetchData.put(url, queryObject);
      if (data?.message && data?.message === "Invalid or expired token.") {
        window.location.href = "/sign-in";
      }
      return data;
    }
    return null;
  },

  getInquiryById: async (id = "") => {
    const url = `api/getInquiry?id=${id}`;
    const data = await fetchData.get(url);
    if (data?.message === "Invalid or expired token.") {
      window.location.href = "/sign-in";
    }
    return data;
  },

  myprofile: async () => {
    const body = {};
    const data = await fetchData.get(`api/profile`, body);
    if (data?.message && data?.message === "Invalid or expired token.") {
      window.location.href = "/sign-in";
    }
    return data;
  },

  updateMyProfile: async (profileData) => {
    try {
      const response = await fetchData.putWithFormData(
        "api/profile",
        profileData
      );
      return {
        ...response,
        // Construct full URL for the profile image if it exists
        profileImage: response.profileImage
          ? `${basePath}${response.profileImage}`
          : null,
      };
    } catch (error) {
      console.error("Error updating profile:", error);
      throw error;
    }
  },
  updateRemark: async () => {},
};

